import React, { useCallback, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import Spinner from "web/components/Spinner";
import Breadcrumb from "web/components/Breadcrumb";
import { Container, TableWrapper } from "../Reports/reportsStyled"
import AddPlusIcon from "web/assets/svg/PtPlusUserAddPlusIcon";
import { Heading, ListingDataWrapper } from "./BuyBackFeeStyled";
import { Table } from 'reactstrap';
import EditIcon from "web/assets/svg/PtPlusUserEditIcon";
import DeleteIcon from "web/assets/svg/PtPlusUserDeleteIcon";
import { breadcrumbMapArr, headerArr, palletTypeOptions } from "./Constants";
import AddFeeFormRow from "./Forms/addEditFormRow";
import { ptPlusBuyBackListing, ptPlusBuyBackMainLocationList, ptPlusBuyBackSubLocationList, ptPlusBuyBackVendorList, ptPlusBuyBackVendorFeeItemDelete } from "redux/actions/adminPTPlusBuyBackFee";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AlertModal from "web/components/AlertModal";
import AddBuyBackCustomerForm from "./Forms/addBuyBackCustomerForm";
import Filters from "./Forms/filters";
import { Pagination } from "@material-ui/lab";
import debounce from "lodash.debounce";
import YesNoModal from "web/components/YesNoModal";

const BuyBackFeeRequests = ({ isDownloadingPtPlusBuyBackFeeCSV, downloadPTPlusBuyBackFeeCSV }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const adminRoles = useSelector(state => state.admin.adminRoles)
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
  const [buyBackFeeListingData, setBuyBackFeeListingData] = useState([]);
  const [customerMainLocationList, setCustomerMainLocationList] = useState([])
  const [customerSubLocationList, setCustomerSubLocationList] = useState([])
  const [vendorLocationList, setVendorLocationList] = useState([])
  const [accordionOpenIndex, setAccordionOpenIndex] = useState()
  const setAccordionFunction = index => {
    setAccordionOpenIndex(index)
  }
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [alertType, setAlertType] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);
  const [addNewFeeItemFormOpen, setAddNewFeeItemFormOpen] = useState(false)
  const [editingPriceID, setEditingPriceID] = useState(false)
  const [editFeeItemData, setEditFeeItemData] = useState()
  const [editVendorData, setEditVendorData] = useState()
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [tableSearch, setTableSearch] = useState('')
  const [deleteItemData, setDeleteItemData] = useState()
  const [yesNoModalOpen, setYesNoModalOpen] = useState(false);
  const yesNoToggleModal = () => setYesNoModalOpen(!yesNoModalOpen);
  const [yesNoModalContent, setYesNoModalContent] = useState();

  //filter state handling
  const [isActive, setIsActive] = useState(true)
  const [filter, setFilter] = useState({
    customerIds: [],
    locationIds: [],
    vendorIds: [],
    active: isActive,
    searchBy: tableSearch
  });

  const handleErrorResponse = (response) => {
    if (response.statusCode === 401) {
      history.push('/sign-in');
      window.location.reload(false);
    } else {
      setPageCount(0)
      setModalContent(response?.data?.error?.message || response.message || response || 'Something went wrong, please try again!')
      setModalLink("");
      toggleModal();
    }
  };


  const getCustomerMainLocationList = async () => {
    try {
      let response = await dispatch(ptPlusBuyBackMainLocationList());
      if (response && response?.success && response?.data && response?.data?.mainLocations) {
        const arr = response?.data?.mainLocations?.map(location => ({
          label: location.locationName,
          value: location.locationId,
        }));
        setCustomerMainLocationList(arr);
      } else {
        handleErrorResponse(response)
      }
    } catch (error) {
      handleErrorResponse(error)
    }
  };

  const getVendorLocationList = async () => {
    try {
      let response = await dispatch(ptPlusBuyBackVendorList());
      if (response && response?.vendorList) {
        const arr = response?.vendorList?.map(location => ({
          label: `${location.locationName} - ${location?.city}, ${location?.state}`,
          value: location.locationId,
          city: location.city,
          state: location.state,
          vendorLocationName: location?.locationName,
        }));
        setVendorLocationList(arr);
      } else {
        handleErrorResponse(response)
      }
    } catch (error) {
      handleErrorResponse(error)
    }
  };

  const getBuyBackListing = async (selectPage, searchText) => {
    try {
      let data = {
        size: 10,
        number: selectPage,
        sort: "DESC",
        searchCriteria: {
          customerIds: filter?.customerIds?.length > 0 ? filter?.customerIds : null,
          locationIds: filter?.locationIds?.length > 0 ? filter?.locationIds : null,
          vendorIds: filter?.vendorIds?.length > 0 ? filter?.vendorIds : null,
          searchBy: searchText || tableSearch || null,
          active: isActive || filter.active
        }
      }
      let response = await dispatch(ptPlusBuyBackListing(data));
      if (response && response?.success && response?.data && response?.data?.buyBackList) {
        setBuyBackFeeListingData(response?.data?.buyBackList);
        setPageCount(response?.data?.totalPages)
      } else {
        handleErrorResponse(response)
      }
    } catch (error) {
      handleErrorResponse(error)
    }
  };

  useEffect(() => {
    let userRole = localStorage.getItem('accountType')
    let appUserRolesList = ['Both', 'Buyer', 'Seller']
    if (userRole !== 'Admin') {
      if (appUserRolesList.includes(userRole)) history.push('/dashboard')
      else history.push('/sign-in')
      window.location.reload();
    }
    getVendorLocationList()
    getCustomerMainLocationList()
    getBuyBackListing(0)
    setPage(1)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);


  const getCustomerSubLocationList = async (locationIds) => {
    try {
      const locationIdsArray = Array.isArray(locationIds) ? locationIds : [locationIds].filter(Boolean);
      const data = { locationIds: locationIdsArray };

      let response = await dispatch(ptPlusBuyBackSubLocationList(data));
      if (response && response?.success && response?.data && response?.data?.locDetList) {
        const arr = response?.data?.locDetList?.map(location => ({
          label: `${location.locationName} - ${location?.city}, ${location?.state}`,
          value: location.locationId,
        }));
        setCustomerSubLocationList(arr);
      } else {
        handleErrorResponse(response)
      }
    } catch (error) {
      handleErrorResponse(error)
    }
  };

  const deleteVendorFeeItem = async () => {
    try {
      let data = {
        id: deleteItemData?.buyBackFeeId,
        vendorLocationId: deleteItemData?.vendorLocationId,
        feeId: deleteItemData?.feeItemId
      }
      let response = await dispatch(ptPlusBuyBackVendorFeeItemDelete(data));
      if (response && (response?.success || response?.data?.success)) {
        setDeleteItemData({})
        setModalContent(response?.msg || response?.data?.msg)
        setAlertType("success")
        setModalLink("");
        toggleModal();
      } else {
        handleErrorResponse(response)
      }
    } catch (error) {
      handleErrorResponse(error)
    }
  };

  const handleDebounceBuyBackFeeSearch = useCallback(
    debounce((selectPage, searchtext) => getBuyBackListing(selectPage, searchtext), 500),
    []
  );

  const handleSearchChange = e => {
    e.preventDefault()
    setTableSearch(e.target.value)
    setPage(1)
    let searchtext = e.target.value
    setBuyBackFeeListingData([])
    handleDebounceBuyBackFeeSearch(0, searchtext);
  }


  const handlePageChange = (event, value) => {
    setPage(value);
    setBuyBackFeeListingData([])
    getBuyBackListing(value - 1, tableSearch)
  };

  const handleExportClick = () => {
    downloadPTPlusBuyBackFeeCSV(filter, tableSearch, dispatch)
  }


  return (
    <>
      {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('PT_PLUS'))) ?
        <>
          <Container>
            <div className="buybackfee-listing">
              <Breadcrumb
                breadcrumbArr={breadcrumbMapArr}
                selected='Buyback Fee'
                title=""
              />
              <AddBuyBackCustomerForm
                customerMainLocationList={customerMainLocationList}
                vendorLocationList={vendorLocationList}
                customerSubLocationList={customerSubLocationList}
                getCustomerSubLocationList={getCustomerSubLocationList}
                toggleModal={toggleModal}
                setModalContent={setModalContent}
                setModalLink={setModalLink}
                setAlertType={setAlertType}
              />
              <TableWrapper>
                {(loaderVisible) && <Spinner />}
                <div className="column">
                  <Heading>
                    <h3>Buyback Fee</h3>
                    <Filters
                      customerMainLocationList={customerMainLocationList}
                      vendorLocationList={vendorLocationList}
                      customerSubLocationList={customerSubLocationList}
                      getCustomerSubLocationList={getCustomerSubLocationList}
                      isActive={isActive}
                      setIsActive={setIsActive}
                      setFilter={setFilter}
                      onFilterChange={filters => setFilter(filters)}
                      handleSearchChange={handleSearchChange}
                      isDownloadingPtPlusBuyBackFeeCSV={isDownloadingPtPlusBuyBackFeeCSV}
                      downloadPTPlusBuyBackFeeCSV={downloadPTPlusBuyBackFeeCSV}
                      handleExportClick={handleExportClick}
                    />
                  </Heading>
                  <ListingDataWrapper>
                    <Table responsive>
                      <thead>
                        <tr style={{ background: "rgba(243, 243, 243, 1)" }}>
                          {headerArr.map((items, index) => (
                            <th key={`table-header-${index}`} style={{ color: "rgba(0, 85, 134, 1)" }}>
                              {(items.title).toUpperCase()}
                            </th>
                          ))}
                          <th>{/*Placeholder for action column*/}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {buyBackFeeListingData && buyBackFeeListingData.length > 0 ? (
                          buyBackFeeListingData.map((items, index) => (
                            <>
                              <tr key={index} className='user-list-table-styles'>
                                <td className="font-weight-bold">{items?.customerName}</td>
                                <td>{items?.customerLocationName}</td>
                                <td colspan="1">{items?.street}</td>
                                <td colspan="1">{items?.city}</td>
                                <td colspan="1">{items?.state}</td>
                                <td
                                  className='expand-collapse-class'
                                  style={{ display: 'flex', alignItems: "center", justifyContent: "end" }}
                                >
                                  <button
                                    style={{
                                      background: '#005586',
                                      color: 'white',
                                      border: 0,
                                      borderRadius: '5px',
                                      padding: '4px 10px',
                                      marginRight: "20px"
                                    }}
                                    onClick={() => {
                                      setEditingPriceID(false);
                                      setAccordionFunction(index)
                                      setAddNewFeeItemFormOpen(prev => {
                                        if (prev !== index) {
                                          return index
                                        } else {
                                          return false
                                        }
                                      })
                                    }}
                                  >
                                    <AddPlusIcon />
                                  </button>

                                  {(accordionOpenIndex === index) ?
                                    <h4 onClick={() => {
                                      setAccordionFunction()
                                      setAddNewFeeItemFormOpen(false);
                                      setEditingPriceID(false);
                                    }}><i></i></h4>
                                    : <h5 onClick={() => {
                                      setAccordionFunction(index)
                                      setEditingPriceID(false);
                                    }}><i></i></h5>
                                  }
                                </td>
                              </tr>

                              {accordionOpenIndex === index &&
                                <tr>
                                  <td colSpan={headerArr.length + 1} style={{ padding: "0" }}>
                                    <table
                                      style={{
                                        background: "#E4F2FA",
                                        width: "100%"
                                      }}
                                      className="fee-items-table"
                                    >
                                      {/* Heading for collapse section */}
                                      <thead>
                                        <tr className='order-details-wrapper-heading'>
                                          <td><h6>Buyback Vendor</h6></td>
                                          <td><h6>Pallet Type</h6></td>
                                          <td><h6>Customer Price</h6></td>
                                          <td><h6>Vendor Price</h6></td>
                                          <td><h6>Start Date</h6></td>
                                          <td><h6>End Date</h6></td>
                                          <td><h6>Comment</h6></td>
                                          <td><h6>Actions</h6></td>
                                        </tr>
                                      </thead>

                                      {/* Fee items */}
                                      <tbody>
                                        {items?.vendors && items?.vendors.map((vendor, vendorIndex) => (
                                          vendor.feeDetails.map((feeDetail, feeIndex) => {
                                            const currentLoopUID = `${items.id}-${feeDetail.feeId}`;
                                            const isEditing = currentLoopUID === editingPriceID;
                                            return isEditing ? <tr>
                                              <td colspan="8" className="px-0 py-0">
                                                <AddFeeFormRow
                                                  key={currentLoopUID}
                                                  vendorLocationList={vendorLocationList}
                                                  buyBackFeeId={items?.id}
                                                  isEdit={true}
                                                  editFeeItemData={editFeeItemData}
                                                  editVendorData={editVendorData}
                                                  toggleModal={toggleModal}
                                                  setModalContent={setModalContent}
                                                  setModalLink={setModalLink}
                                                  setAlertType={setAlertType}
                                                />
                                              </td>
                                            </tr> : <tr className='order-details-wrapper' key={`${vendorIndex}-${feeIndex}`}>
                                              <td>
                                                <p style={{ whiteSpace: 'nowrap' }}>{`${vendor?.vendorLocationName} - ${vendor?.city}, ${vendor?.state}`}</p>
                                              </td>
                                              <td>
                                                <p style={{ whiteSpace: 'nowrap' }}>
                                                  {palletTypeOptions.map(option => {
                                                    if (option.value === feeDetail?.pickupPalletType) {
                                                      return option.label;
                                                    };
                                                  })}
                                                </p>
                                              </td>
                                              <td>
                                                <p style={{ whiteSpace: 'nowrap' }}>
                                                  ${feeDetail?.customerFee?.toFixed(2)}
                                                </p>
                                              </td>
                                              <td>
                                                <p style={{ whiteSpace: 'nowrap' }}>
                                                  ${feeDetail?.vendorFee?.toFixed(2)}
                                                </p>
                                              </td>
                                              <td>
                                                <p>{feeDetail?.rateStartDate}</p>
                                              </td>
                                              <td>
                                                <p>{feeDetail?.rateExpirationDate}</p>
                                              </td>
                                              <td>
                                                <p title={feeDetail?.comment}>
                                                  {feeDetail?.comment?.length > 20 ? (feeDetail?.comment?.substring(0, 20).concat('...')) : (feeDetail?.comment ? feeDetail?.comment : 'NA')}
                                                </p>
                                              </td>
                                              <td className='expand-collapse-class' style={{ width: '100%', display: 'flex', position: 'relative', gap: "5px" }}>
                                                <div
                                                  onClick={() => {
                                                    setAddNewFeeItemFormOpen(false);
                                                    setEditingPriceID(currentLoopUID)
                                                    setEditFeeItemData(feeDetail)
                                                    setEditVendorData(vendor)
                                                  }}
                                                >
                                                  <EditIcon />
                                                </div>
                                                <div
                                                  onClick={() => {
                                                    setDeleteItemData({
                                                      buyBackFeeId: items.id,
                                                      feeItemId: feeDetail.feeId,
                                                      vendorLocationId: vendor.vendorLocationId
                                                    })
                                                    setYesNoModalContent('Are you sure you want to delete this item?');
                                                    yesNoToggleModal();
                                                  }

                                                  }
                                                ><DeleteIcon /></div>
                                              </td>
                                            </tr>
                                          })
                                        ))}
                                        {
                                          (addNewFeeItemFormOpen === index) &&
                                          <tr>
                                            <td colspan="8" className="px-0 py-0">
                                              <AddFeeFormRow
                                                vendorLocationList={vendorLocationList}
                                                buyBackFeeId={items?.id}
                                                isEdit={false}
                                                toggleModal={toggleModal}
                                                setModalContent={setModalContent}
                                                setModalLink={setModalLink}
                                                setAlertType={setAlertType}
                                              />
                                            </td>
                                          </tr>
                                        }
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              }
                            </>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={headerArr.length + 1} className="text-center">No Data Found</td>
                          </tr>
                        )}
                      </tbody>

                    </Table>
                    {pageCount && buyBackFeeListingData && buyBackFeeListingData?.length !== 0 ? <Pagination count={pageCount}
                      page={page}
                      onChange={handlePageChange} /> : ""}
                  </ListingDataWrapper>
                </div>
              </TableWrapper>
            </div>
          </Container>
          <YesNoModal
            isOpen={yesNoModalOpen}
            toggle={yesNoToggleModal}
            title=""
            onClickHander={(val) => {
              if (val === "no") {
                yesNoToggleModal()
              } else {
                deleteVendorFeeItem()
                yesNoToggleModal()
              }
            }}
            content={yesNoModalContent}
            link="/ptplus-buyback-fee"
          />
          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title={""}
            alertType={alertType}
            content={modalContent}
            link={modalLink}
            className="alert-msg-container"
            InnerClassName="alert-msg"
            callBackAlert={(val) => {
              if (val === "success") {
                getBuyBackListing(0, tableSearch)
                setPageCount(0)
                setPage(1)
                setAccordionOpenIndex()
                setAddNewFeeItemFormOpen(false)
              } else {
                toggleModal()
              }
            }}
          />

        </>
        :
        <p>You are not authorized to view this page.</p>
      }
    </>
  )

}

export default BuyBackFeeRequests
